import Vue from 'vue'
import EventBus from '@/vue/events/event-bus'

export default {
  methods : {
    teamMouseOver(event) {
      if(event) {
        var elem = $('.sportTable').find('#'+event.eveid)
        if (elem.length > 0) {
          elem.css("display","block")
        }
      }
    },
    teamMouseLeave(event) {
      if(event) {
        var elem = $('.sportTable').find('#'+event.eveid)
        if (elem.length > 0) {
          elem.css("display","")
        }
      }
    },
    favourite(event, isrb) {
      this.$store.commit('FAVOURITEEVENT', { event : event, isrb: isrb })
      if(this.$store.getters.showFavEvents){
        this.$store.dispatch('getSportOdds', { 
          showfavorite: true,
          callback: ((res) => {
            EventBus.$emit('refreshOdd', true)
          }).bind(this)
        })
      }

      if(Object.keys(this.$store.getters.favouriteEvents).length <=0 && Object.keys(this.$store.getters.favouriteLgeEvents).length <=0 && this.$store.getters.showFavEvents == true){
        EventBus.$emit('changemain', true)
      }
    },
    favouritelgeve(lgeid, wevent, isrb, eventObj) {
      wevent.preventDefault()
      wevent.stopPropagation()
      var lgChk = $(wevent.target).hasClass('added')
      this.$store.commit('FAVOURITELGEVENT', { lgeid : lgeid, lgeChk: lgChk, isrb: isrb, eventObj: eventObj })
      
      if(this.$store.getters.showFavEvents){
        this.$store.dispatch('getSportOdds', {
          showfavorite: true,
          callback: ((res) => {
            EventBus.$emit('refreshOdd', true)
          }).bind(this)
        })
      }
      if(Object.keys(this.$store.getters.favouriteEvents).length <=0 && Object.keys(this.$store.getters.favouriteLgeEvents).length <=0 && this.$store.getters.showFavEvents == true){
        EventBus.$emit('changemain', true)
      }
    },
    lgFavorite(lgId,btPage,favouriteLgeEvents) {
      var lgeFav = false
      if(favouriteLgeEvents!=undefined && favouriteLgeEvents[btPage]!=undefined){
        if(favouriteLgeEvents[btPage].includes(lgId)){
          lgeFav = true
        }
      }
      return lgeFav
    },
    favouriteOtr(event, sportId,wevent) {
      wevent.preventDefault()
      wevent.stopPropagation()
      this.$store.commit('FAVOURITEOTREVENT', { eveId : event, selectedSport: sportId }) 
      
      EventBus.$emit('sportSelectedAllBetChange', true)
      this.$store.dispatch('getSportOutrightOdds', {
        callback: ((res) => {
          EventBus.$emit('refreshOdd', true)
        }).bind(this)
      })
    },
    otrFavorite(eId,btPage,favouriteOTREvents) {
      var lgeFav = false
      if(favouriteOTREvents!=undefined && favouriteOTREvents[btPage]!=undefined){
        if(favouriteOTREvents[btPage].includes(eId)){
          lgeFav = true
        }
      }
      return lgeFav
    },
    lgAllBetFavorite(lgMatches) {
      var lgeFav = true
      if(lgMatches.isFavourite==undefined || !lgMatches.isFavourite){
        lgeFav = false
      }
      return lgeFav
    },
    showForecast(event,windowEvent) {
      this.$store.commit('SPORTFORECAST_TOGGLE', true)
      this.$store.commit('SPORTFORECAST_SELECTEDEVENT', event)
      this.$store.commit('SPORTFORECAST_WINDOWEVENT', windowEvent)
      EventBus.$emit('SHOW_FORECAST',event)

      //if have betform show then calculate immediate
      if(this.$store.getters.betForm.length > 0 && !this.$store.getters.betting.success) {
        EventBus.$emit('FORECAST_GETWAITINGLIST', event)
      }else{
        EventBus.$emit('FORECAST_GETWAITINGLIST', null)
      }
    },

  }
}



// WEBPACK FOOTER //
// ./resources/wob/vue/mixins/favourite.js